import { connect } from 'react-redux';
import View from './ToastMessengerView';

import { messagesSelector } from './ToastMessengerSelector';

const mapStateToProps = state => ({
  messages: messagesSelector(state),
});

export default connect(mapStateToProps)(View);
